import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app'

require('es6-promise/auto');

ReactDOM.render(
	<App />,
	document.querySelector('.app')
)


// WEBPACK FOOTER //
// ./src/index.js